import { Component, inject, Input } from '@angular/core';
import { faHeartBroken } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MySearchesService } from '../../../../services/bidder-community/my-searches/my-searches.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-result',
  imports: [FontAwesomeModule],
  templateUrl: './no-result.component.html',
  styleUrl: './no-result.component.scss'
})
export class NoResultComponent {

  private readonly searchAccountService = inject(MySearchesService);
  private readonly router = inject(Router)


  @Input() query!: string;

  faHeartBroken = faHeartBroken;



  onPostNewSearch(q: string) {
    this.searchAccountService.postMySearch(q).subscribe({
      next: () => {
        this.router.navigate(['/my-account/my-searches']);
      }
    });
  }

}
